import { render, staticRenderFns } from "./joinResult.vue?vue&type=template&id=08b19533&scoped=true&"
import script from "./joinResult.vue?vue&type=script&lang=js&"
export * from "./joinResult.vue?vue&type=script&lang=js&"
import style0 from "./joinResult.vue?vue&type=style&index=0&id=08b19533&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b19533",
  null
  
)

export default component.exports